import { useEffect } from 'react'

type IntersectionObserverCallback = (
  entries: IntersectionObserverEntry[],
  observer: IntersectionObserver
) => void

type IntersectionObserverOptions = IntersectionObserverInit

type UseIntersectionObserverProps = {
  elementIdentifier: string
  options?: IntersectionObserverOptions
  onIntersect: IntersectionObserverCallback
}
const useIntersectionObserver = ({
  elementIdentifier,
  options,
  onIntersect
}: UseIntersectionObserverProps) => {
  useEffect(() => {
    const element = document.querySelector(`${elementIdentifier}`)

    if (!element) {
      return () => undefined
    }

    const observer = new IntersectionObserver(onIntersect, options)

    observer.observe(element)

    return () => {
      observer.unobserve(element)
    }
  }, [elementIdentifier, options, onIntersect])
}

export default useIntersectionObserver
